export default {
  API_ERROR: "Съжаляваме, нещо се обърка. Моля, опитайте отново.",
  FORM_ERROR: "Съжаляваме, но трябва да напишете малко повече, за да ни изпратите обратна връзка."
}
